import { Injectable } from '@angular/core';
import { UrlConnectionEnum } from 'src/app/enums/connection/url-connection.enum';
import { HttpService } from '../http-service/http.service';

@Injectable({
    providedIn: 'root'
})
export class StoreService {

    constructor(private httpService: HttpService) { }

    /**
     * Creates new participant
     * @author Starley Cazorla
     * @param cpf 
     * @returns  
     */
    createNewParticipant(cpf: string) {
        return new Promise((resolve, reject) => {

            let config = this.httpService.setHeaderConfig(true);

            this.httpService.post(UrlConnectionEnum.CREATE_NEW_PARTICIPANT, { cpf: cpf }, config).subscribe({
                next: (data) => {
                    resolve(data);
                },
                error: (error) => {
                    reject(error);
                }
            })

        })
    }

    /**
     * Gets products to store page
     * @author Starley Cazorla
     * @param ltm_id 
     * @returns  
     */
    getStoreProducts(ltm_id: any) {
        return new Promise((resolve, reject) => {

            let config = this.httpService.setHeaderConfig(true);

            this.httpService.post(UrlConnectionEnum.GET_STORE_PRODUCTS, { ltm_id: ltm_id }, config).subscribe({
                next: (data) => {
                    resolve(data);
                },
                error: (error) => {
                    reject(error);
                }
            })
        })
    }

    /**
     * Gets list products when store list product page
     * @author Starley Cazorla
     * @param configData 
     * @returns  
     */
    getListProducts(configData: any) {
        return new Promise((resolve, reject) => {

            let config = this.httpService.setHeaderConfig(true);

            this.httpService.get(UrlConnectionEnum.GET_LIST_PROCUTCTS, configData, config).subscribe({
                next: (data) => {
                    resolve(data);
                },
                error: (error) => {
                    reject(error);
                }
            })
        })
    }

    /**
     * Gets vitrine
     * @author Starley Cazorla
     * @param ltm_id 
     * @returns  
     */
    getVitrine(ltm_id: any) {
        return new Promise((resolve, reject) => {

            let config = this.httpService.setHeaderConfig(true);

            this.httpService.get(UrlConnectionEnum.GET_STORE_VITRINE, { ltm_id: ltm_id }, config).subscribe({
                next: (data) => {
                    resolve(data);
                },
                error: (error) => {
                    reject(error);
                }
            })
        })
    }

    /**
     * Searchs price
     * @author Starley Cazorla
     * @param dataToSearch 
     * @returns  
     */
    searchPrice(dataToSearch: any) {
        return new Promise((resolve, reject) => {

            let config = this.httpService.setHeaderConfig(true);

            this.httpService.get(UrlConnectionEnum.SEARCH_STORE_PRICE, dataToSearch, config).subscribe({
                next: (data) => {
                    resolve(data);
                },
                error: (error) => {
                    reject(error);
                }
            })
        })
    }

    /**
     * Gets categorys
     * @author Starley Cazorla
     * @param ltm_id 
     * @returns  
     */
    getCategorys(ltm_id: any) {
        return new Promise((resolve, reject) => {

            let config = this.httpService.setHeaderConfig(true);

            this.httpService.get(UrlConnectionEnum.GET_STORE_CATEGORIES, { ltm_id: ltm_id }, config).subscribe({
                next: (data) => {
                    resolve(data);
                },
                error: (error) => {
                    reject(error);
                }
            })
        })
    }

    /**
     * Gets calculate frete
     * @author Starley Cazorla
     * @param calcCep 
     * @returns  
     */
    getCalculateFrete(calcCep: any) {
        return new Promise((resolve, reject) => {

            let config = this.httpService.setHeaderConfig(true);

            this.httpService.get(UrlConnectionEnum.STORE_FRETE_SIMULATE, calcCep, config).subscribe({
                next: (data) => {
                    resolve(data);
                },
                error: (error) => {
                    reject(error);
                }
            })
        })
    }

    /**
     * Checkouts store
     * @author Starley Cazorla
     * @param checkoutData 
     * @returns  
     */
    checkoutStore(checkoutData: any) {
        return new Promise((resolve, reject) => {

            let config = this.httpService.setHeaderConfig(true);

            this.httpService.post(UrlConnectionEnum.STORE_CHECKOUT, checkoutData, config).subscribe({
                next: (data) => {
                    resolve(data);
                },
                error: (error) => {
                    reject(error);
                }
            })
        })
    }

    /**
     * Gets product details
     * @author Starley Cazorla
     * @param productData 
     * @returns  
     */
    getProductDetails(productData: any) {
        return new Promise((resolve, reject) => {

            let config = this.httpService.setHeaderConfig(true);

            this.httpService.get(UrlConnectionEnum.GET_STORE_PRODUCT_DETAILS, productData, config).subscribe({
                next: (data) => {
                    resolve(data);
                },
                error: (error) => {
                    reject(error);
                }
            })
        });
    }
}
